export const ROUTE_NAME = {
  HOME: "home",

  // auth
  AUTH: "auth",
  AUTH_LOGIN: "auth-login",
  AUTH_FORGOT: "auth-forgot",
  AUTH_RESET: "auth-reset",
  AUTH_UPDATE: "auth-update",
  AUTH_LOGOUT: "auth-logout",
  SSO_LOGIN: "sso-login",

  // dashboard
  DASHBOARD: "dashboard",

  // CONTENT VALIDATOR HUMAN
  CONTENT_VALIDATOR_HUMAN: "content-validator-human",
  VCC_IMPORT: "vcc-import",
  UPLOAD: "upload",
  VALIDATE_RESULT: "validate-result",

  CONTENT_VALIDATOR_TECH_CONNECT: "tech-connect",

  // analytics (old stats dashboard)
  ANALYTICS: "analytics",

  // external api
  EXTERNAL_API: "external-api",

  // administration
  ADMINISTRATION: "administration",
  USER: "user",
  USER_PERMISSIONS: "permissions",
  COMPANY_SETTINGS: "company-settings",

  // billing
  BILLING: "billing",
  PURCHASE_CREDITS: "purchase-credits",
  USAGE: "usage",
  PLAN: "plan",
  BILLING_PLAN: "plan",
  PLAN_OVERVIEW: "plan-overview",
  PLAN_MANAGE_PLAN: "manage-plan",
  PLAN_COMPARE: "compare-plan",
  KEYS: "keys",
  EVALUATION: "evaluation",

  // help center
  HELP_CENTER: "help-center",

  // platform redirect interstitial
  REDIRECTING: "redirecting",
};
